import { toast } from "react-toastify";

const HandleError = error => {
    if (error.status_code == 401) {
        localStorage.removeItem("security_auth");
        toast.error(error.message);
        setTimeout(() => {
            window.location.href = "/login"
        }, 500);
    }
};
export default HandleError;
